import axios from '../helpers/axios'
import { logError } from '../services';
import { IResponse, IRole, IRoleDetail, IRolePartsPost, IRolePost } from '../models';

export const getAdminRoles = async (roleId: number | undefined | null = null): Promise<IResponse<IRole[]>> => {
  try {
    const { data } = await axios.get(`/api/place-order/roles?id=${roleId}`);
    return data;
  } catch (error) {
    logError(error, 'getAdminRoles failed');
    return Promise.reject(error);
  }
};

export const getAdminRole = async (placeOrderRoleId: number): Promise<IRoleDetail> => {
  try {
    const { data } = await axios.get(`/api/place-order/roles/${placeOrderRoleId}`);
    return data;
  } catch (error) {
    logError(error, 'getAdminRole failed');
    return Promise.reject(error);
  }
};

export const updateAdminRole = async (post: IRolePost): Promise<any[]> => {
  try {
    const { data } = await axios.post(`/api/place-order/roles`, post);
    return data;
  } catch (error) {
    logError({ error, payload: post }, 'updateAdminRole failed');
    return Promise.reject(error);
  }
};
export const updateAdminRoleParts = async (post: IRolePartsPost): Promise<any[]> => {
  try {
    const { data } = await axios.post(`/api/place-order/roles/parts`, post);
    return data;
  } catch (error) {
    logError({ error, payload: post }, 'updateAdminRoleParts failed');
    return Promise.reject(error);
  }
};

export const deleteAdminRole = async (roleId: number): Promise<any[]> => {
  try {
    const { data } = await axios.delete(`/api/place-order/roles/${roleId}`);
    return data;
  } catch (error) {
    logError(error, 'deleteAdminRole failed');
    return Promise.reject(error);
  }
};

export const getAdminRoleCategories = async (placeOrderRoleIdorIds?: number | number[]): Promise<any> => {
  try {
    var params = new URLSearchParams();

    if (typeof placeOrderRoleIdorIds === 'number') {
      params.append('placeOrderRoleId', placeOrderRoleIdorIds.toString());
    } else {
      for (let i = 0; i < placeOrderRoleIdorIds.length; i++) {
        params.append('placeOrderRoleId', placeOrderRoleIdorIds[i].toString());
      }
    }
    const { data } = await axios.get(`/api/place-order/roles/part-categories`, {
      params
    });
    return data;
  } catch (error) {
    logError(error, 'getAdminRoleCategories failed');
    return Promise.reject(error);
  }
};

export const getAvailableAdminRoles = async (id?: number): Promise<any> => {
  try {
    const { data } = await axios.get(`/api/place-order/roles/available?RoleId=${id}`);
    return data;
  } catch (error) {
    logError(error, 'getAvailableAdminRoles failed');
    return Promise.reject(error);
  }
};
